import { CodebookModel } from 'app/shared/model/shared.model';

export interface ConstructionBuildingProcedure {
  buildingNumber: CodebookModel[];
  constructionNumber: CodebookModel[];
  procedureNumber: CodebookModel[];
}

export const initialConstructionBuildingProcedure = {
  buildingNumber: [],
  constructionNumber: [],
  procedureNumber: [],
};
